import { render, staticRenderFns } from "./Testimoni.vue?vue&type=template&id=85ad1fae&scoped=true"
import script from "./Testimoni.vue?vue&type=script&lang=js"
export * from "./Testimoni.vue?vue&type=script&lang=js"
import style0 from "./Testimoni.vue?vue&type=style&index=0&id=85ad1fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ad1fae",
  null
  
)

export default component.exports